export const env = {
  apiUrl: (import.meta.env.VITE_API_URL as string | undefined) ?? 'http://localhost:3000',
  botUsername: (import.meta.env.VITE_BOT_USERNAME as string | undefined) ?? '',
};
